import Store from './Store.js';
const moment = require('moment');

class Utils {
  // constructor() {
  // }
  genKey = (length) => {
     var result           = '';
     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
     var charactersLength = characters.length;
     for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }

  log() {

    }
  serverLog() {
    let arg = localStorage.getItem('car_serverlog') === null ? [] : JSON.parse(localStorage.getItem('car_serverlog'));
    console.log("arg", arg)
    let v = {};
    v['logtime']= moment().format('X')
    v['logdata']= arguments
    arg.push(v);
    localStorage.setItem('car_serverlog', JSON.stringify(arg))
  }

  copyObject = (obj) => {
    return JSON.parse(JSON.stringify(obj))
  }

  setEnv(module_name) {
    let api_url = process.env.REACT_APP_API_URL;
    Store.updateStore('module_name',module_name);
    Store.updateStore('api_url',api_url);
    Store.updateStore('is_admin',false);
    Store.updateStore('is_debug',false);

  }

  adddaystoDate(days) {
    let t = parseInt(days);
    console.log("t", t)
    var response_time = new Date();
    console.log("response_time", response_time)
    response_time.setDate(response_time.getDate() + parseInt(t))
    let curmonth = parseInt(response_time.getMonth());
    let newcurmonth = curmonth + 1;
    var dueDateStr = newcurmonth >= 10 ? response_time.getFullYear()+'/'+newcurmonth+'/' : response_time.getFullYear()+'/0'+newcurmonth+'/';
    dueDateStr += response_time.getDate() < 10 ? '0' + response_time.getDate() : response_time.getDate();
    return dueDateStr; //yyyy/mm/dd
  }

  isBase64(str) {
      if (str ==='' || str.trim() ===''){ return false; }
      try {
          return btoa(atob(str)) == str;
      } catch (err) {
          return false;
      }
  }

  showCompanyUsers(company_id, type) {
      let list_answrere = [];
      let gc_assoc = Store.getStoreData('gc_assoc');
      let contacts = Store.getStoreData('contacts');
      let user_roles = Store.getStoreData('user_roles');
      let role = Store.getStoreData('role');
      let contact_id = Store.getStoreData('contact_id');
      console.log("gc_assoc", gc_assoc[company_id.toString()].users)


      for(let gcu in gc_assoc[company_id.toString()].users) {
          for(let c in contacts) {
              if(parseInt(gcu) === parseInt(c)) {
                  if(type === "answrer") {
                      if(user_roles[c.toString()] !=='team' && user_roles[c.toString()] !=='no_access') {
                          if(role === 'jr_ca' && parseInt(c) !== parseInt(contact_id)){
                            list_answrere.push({"ID" : c, "contact_name": contacts[c.toString()] })
                          }else{
                            list_answrere.push({"ID" : c, "contact_name": contacts[c.toString()] })
                          }
                      }
                  } else if(type === "approvar") {
                     if(parseInt(c) !== parseInt(contact_id) && (user_roles[c.toString()]  === 'admin_manager' || user_roles[c.toString()]  === 'ca' || user_roles[c.toString()]  === 'ca_module_admin') && user_roles[c.toString()]  !== 'no_access' ) {
                      list_answrere.push({"ID" : c, "contact_name": contacts[c.toString()] })
                    }
                  }
              }
          }
      }
      list_answrere.sort(this.compare);
      list_answrere.unshift({"ID": "0", "contact_name":"Compliance Advisers"});
      return list_answrere;
  }

  showListAssignedUser(company_id) {
    let result = {'ca': [], 'teams': [], 'users': []};
    let moduleconfig = Store.getStoreData('moduleconfig');
    let contacts = Store.getStoreData('contacts');
    let gc_assoc = Store.getStoreData('gc_assoc');
    let user_roles = Store.getStoreData('user_roles');
    let role = Store.getStoreData('role');
    let org_teams = Store.getStoreData('org_teams');
    if(moduleconfig.specific_user_assignment_enabled){
      result['ca'].push({"ID": "0", "contact_name":"Compliance Advisers"})
    }
    let team_assoc = {}
    if(moduleconfig.team_assignment_enabled){
      for(let key in org_teams){
          for(let g in gc_assoc[company_id.toString()].users) {
            if(org_teams[key.toString()].active && org_teams[key.toString()].members[g.toString()] === 1 && user_roles[g.toString()] !=='team' && user_roles[g.toString()] !=='no_access' && contacts[g.toString()]){

              team_assoc[key.toString()] = org_teams[key.toString()].name
          }
        }
      }

    }
    console.log("team_assoc", team_assoc)
    for(let ta in team_assoc){
      result['teams'].push({"ID": ta, "contact_name": team_assoc[ta.toString()]})
    }
    result['teams'].sort(this.compare);


    if(moduleconfig.specific_user_assignment_enabled && moduleconfig.requesting_user_assignment_enabled) {
        for(let g in gc_assoc[company_id.toString()].users) {
          if(user_roles[g.toString()] !=='team' && user_roles[g.toString()] !=='no_access' && contacts[g.toString()]){
            result['users'].push({"ID": g, "contact_name": contacts[g.toString()]})
        }
      }
    }
    result['users'].sort(this.compare);
    return result


  }

  ShowTeamUsers(company_id) {
      let moduleconfig = Store.getStoreData('moduleconfig');
      let contacts = Store.getStoreData('contacts');
      let gc_assoc = Store.getStoreData('gc_assoc');
      let user_roles = Store.getStoreData('user_roles');
      let role = Store.getStoreData('role');
      let org_teams = Store.getStoreData('org_teams');
      console.log("org_teams", org_teams, company_id, contacts)
      let teams = [];
      let team_assoc = {}

      if(moduleconfig.team_assignment_enabled){
        for(let key in org_teams){
            for(let g in gc_assoc[company_id.toString()].users) {
              if(contacts[g.toString()] && org_teams[key.toString()].active && org_teams[key.toString()].members[g.toString()] === 1 && user_roles[g.toString()] !=='team' && user_roles[g.toString()] !=='no_access'){

                team_assoc[key.toString()] = org_teams[key.toString()].name
            }
          }
        }
        console.log("team_assoc", team_assoc)
        for(let ta in team_assoc){
          teams.push({"ID": ta, "contact_name": team_assoc[ta.toString()]})
        }

        teams.sort(this.compare);

      }
      // console.log("team_assoc", teams)

      if(moduleconfig.specific_user_assignment_enabled && moduleconfig.requesting_user_assignment_enabled) {
          for(let g in gc_assoc[company_id.toString()].users) {
            if(user_roles[g.toString()] !=='team' && user_roles[g.toString()] !=='no_access' && contacts[g.toString()] ){
              teams.push({"ID": g, "contact_name": contacts[g.toString()]})
          }
        }
        console.log("teams", teams)
        if(teams.length > 0)teams.sort(this.compare);
      }


      if(moduleconfig.specific_user_assignment_enabled){
        teams.unshift({"ID": "0", "contact_name":"Compliance Advisers"});
      }
      return teams;
  }

  getTeamUsers(team_id){
    let teams = {};
    let user_roles = Store.getStoreData('user_roles');
    let org_teams = Store.getStoreData('org_teams');
    let contacts = Store.getStoreData('contacts');

    if(team_id in org_teams){
      let org_team_members = org_teams[team_id.toString()].members;
      for(let m in org_team_members) {
        if(user_roles[m.toString()] !=='team' && user_roles[m.toString()] !=='no_access' && contacts[m.toString()] ){
          teams[m.toString()] = 1;
        }
      }
    }
    console.log("teams", teams)
    return teams;
  }

  getMailUsers(team_id, company_id) {
    let users = {};
    let user_roles = Store.getStoreData('user_roles');
    let contacts = Store.getStoreData('contacts');
    let gc_assoc = Store.getStoreData('gc_assoc');
    let role = Store.getStoreData('role');

    if(team_id!==0) {
      let org_teams = Store.getStoreData('org_teams');
      let org_team_members = team_id in org_teams ? org_teams[team_id.toString()].members : {};
      for(let m in org_team_members) {
        if(user_roles[m.toString()] !=='team' && user_roles[m.toString()] !=='no_access'){
          users[m.toString()] = 1;
        }
      }
    }else{
        for(let g in gc_assoc[company_id.toString()].users) {
          if(user_roles[g.toString()] !=='team' && user_roles[g.toString()] !=='no_access' && contacts[g.toString()] ){
            users[g.toString()] = 1;
        }
      }
    }
    return users;
  }

  compare(a, b) {
      const bandA = a.contact_name.toUpperCase();
      const bandB = b.contact_name.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
   }

  baseImage() {
    var ImageURL = "data:image/png;base64,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";
    return ImageURL
  }

  timeToDate(time){
    var t = Math.round(time/1000);
    let last_time = moment.unix(t);
    let date  = last_time.format("DD/MM/YYYY");
    return date;
  }

}

export default new Utils();
